import UIComponent from "../../common/UIComponent";
import "./index.css";
const TENCENT_DELAY = 90;

export default class H5LiveShiftTime extends UIComponent {
  constructor(elementId, interfaces) {
    super()
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();

    this.interfaces.on(VhallPlayer.TIMEUPDATE, (e) => {
      this.h5currentTime.innerText = this._formatTime(e.playedDate);
    });

    this.interfaces.on(VhallPlayer.LOADED, (e) => {
        this.h5currentTime.setAttribute("class", "vhallPlayerh5-startTime display");
    })
  }

  init() {
    this.h5currentTime = document.createElement("span");
    this.h5currentTime.setAttribute("class", "vhallPlayerh5-startTime hide");
    this.h5currentTime.innerText = "00:00:00";

    this.insertElement(this.elementId, this.h5currentTime);
  }

  _secondToDate(result) {
    var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
    var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
    var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
    return result = h + ":" + m + ":" + s;
  }

  _formatTime(now) {
    const format  = new Date(now).Format('yyyy-MM-dd hh:mm:ss');
    return format.split(' ')[1];
    // const h = now.getHours();
    // const m = now.getMinutes();
    // const s = now.getSeconds();
    // return `${h}:${m}:${s}`;
  }
}